import { createListValidator, createValidator, required } from '@widgets/validation'
import { DistribuicaoBolsas } from './distribuicao-bolsas.model'

export const distribuicaoBolsasValidator = createValidator<{ distribuicoes: DistribuicaoBolsas[] }>(
  {},
  (values, errors) => {
    errors.distribuicoes = distribuicaoBolsasItemValidator(values.distribuicoes)
    return errors
  }
)

const distribuicaoBolsasItemValidator = createListValidator(
  createValidator<DistribuicaoBolsas>({
    numeroBolsasAprovadas: [required],
  })
)
